import React from "react";
import { string } from "prop-types";

const Instagram = ({ color1 = "#121212", color2 = "#fff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
    <g data-name="Group 3680">
      <g data-name="Group 3679">
        <circle cx="14" cy="14" r="14" data-name="Ellipse 3" fill={color1} />
      </g>
      <path
        d="M14.255 10.41a3.589 3.589 0 103.589 3.589 3.583 3.583 0 00-3.589-3.589zm0 5.922a2.333 2.333 0 112.333-2.334 2.337 2.337 0 01-2.333 2.333zm4.573-6.069a.837.837 0 11-.837-.837.835.835 0 01.837.837zm2.377.85a4.142 4.142 0 00-1.132-2.938 4.169 4.169 0 00-2.933-1.131c-1.156-.066-4.619-.066-5.775 0a4.164 4.164 0 00-2.937 1.131 4.156 4.156 0 00-1.126 2.934c-.066 1.156-.066 4.619 0 5.775a4.142 4.142 0 001.126 2.933 4.175 4.175 0 002.933 1.131c1.156.066 4.619.066 5.775 0a4.142 4.142 0 002.933-1.131 4.17 4.17 0 001.131-2.933c.066-1.156.066-4.616 0-5.772zm-1.493 7.012a2.362 2.362 0 01-1.331 1.331 15.426 15.426 0 01-4.126.281 15.546 15.546 0 01-4.127-.282 2.362 2.362 0 01-1.33-1.331 15.426 15.426 0 01-.281-4.126 15.546 15.546 0 01.281-4.123 2.362 2.362 0 011.33-1.333 15.426 15.426 0 014.126-.281 15.546 15.546 0 014.126.281 2.362 2.362 0 011.331 1.333 15.426 15.426 0 01.281 4.126 15.417 15.417 0 01-.281 4.123z"
        data-name="Path 184"
        fill={color2}
      />
    </g>
  </svg>
);

Instagram.propTypes = {
  color1: string,
  color2: string
};

export default Instagram;
